module.exports = __webpack_public_path__ + "img/communication-studies-b.1ccf2b5c.jpg";